import { RawButton } from '@ps/web-shared-components';
import type { RawButtonProps } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import Next from '@swf/core/assets/icons/next.svg';

import styles from './NextButton.scss';

const NextButton: React.FC<RawButtonProps> = (props) => (
  <RawButton {...props} className={classNames(styles.button, props.className)}>
    {props.children}
    <Next />
  </RawButton>
);

export default NextButton;
